import SuperTokens, { SuperTokensWrapper } from "supertokens-auth-react";
import Passwordless from "supertokens-auth-react/recipe/passwordless";
import Session from "supertokens-auth-react/recipe/session";
import { SERVER_URL, WEBSITE_URL } from "../config/app.config";
import { post } from "../config/api.js";
import IntercomService from "../thirdparty/IntercomService.js";

class SuperTokensService {
	static async initialise() {
		try {

            SuperTokens.init({
                appInfo: {
                    appName: "Xookeeper App",
                    apiDomain: SERVER_URL,
                    websiteDomain: WEBSITE_URL,
                    apiBasePath: "/auth",
                    websiteBasePath: "/auth"
                },
                
                getRedirectionURL: async (context) => {
                    if (context.action === "SUCCESS" && context.newSessionCreated) {
                        if (context.redirectToPath !== undefined) {
                            // we are navigating back to where the user was before they authenticated
                            return context.redirectToPath;
                        }

                        if (context.createdNewUser) {
                            // user signed up
                        } else {
                            // user signed in
                        }
                        return "/";
                    }
                    return undefined;
                },
                recipeList: [
                    Passwordless.init({
                        contactMethod: "EMAIL",
                        onHandleEvent: (event) => {
                            if (event.action === "SUCCESS") {
                                IntercomService.initialize();
                            } else if (event.action === "SIGN_OUT") {
                                window.Intercom('shutdown');
                            }
                        }
                    }),
                    Session.init()
                ]
            });


		} catch (error) {
			console.log(error);
			return { intialised: false, intialisationError: error };
		}

            // Check for existing session on initialization
        try {
            const session = await Session.doesSessionExist();
            if (session) {
                const userId = await Session.getUserId();
                IntercomService.initialize(userId);
            }
            
        } catch (err) {
            console.error('Error checking existing session:', err);
        }


		return { intialised: true };
	}

    static async signIn(payload) {
        const url = `${SERVER_URL}/auth/signinup/code`;
        return await post({ url, data: payload, thirdPartyRequest: true });
    }

    static async validateOtp(payload) {
        const url = `${SERVER_URL}/auth/signinup/code/consume`;
        return await post({ url, data: payload, thirdPartyRequest: true });
    }

    static async doesSessionExist() {
        return await SuperTokens.doesSessionExist();
    }

    static async signOut() {
        try {
            await SuperTokens.signOut();
            return { success: true };
        } catch(error) {
            console.log(error);
            return { success: false };
        }
    }

}

export default SuperTokensService;